import { Container, Rectangle, utils } from 'pixi.js';
import { InteractionEvents, ScreenPin } from "@cc/pixi-app";
import Viewport from '../../../node_modules/pixi-viewport';
import { ScreenBase } from "./ScreenBase";
import { Tilemap } from '../map/tilemap';
import { Player } from '../common/Player';
import { session } from './../session';
import { MissionRunner } from '../missions/MissionRunner';
import { GameUI } from './../game/GameUI';
import { Controller } from './../game/Controller';
import { storageManager } from './../common/StorageManager';
import { UiScreen } from './../game/UiScreen';
import { Tutorial } from '../game/Tutorial';
import { Command } from './../missions/Command';
import { AIController } from './../game/AIController';
import { dataImporter } from './../DataImporter';


/**
 */
export class ScreenGame extends ScreenBase {
    static action = {
        moveUp: 'MOVE_UP',
        moveDown: 'MOVE_DOWN',
        moveLeft: 'MOVE_LEFT',
        moveRight: 'MOVE_RIGHT',
        interact: 'INTERACT'
    };

    /**
     */
    init() {

        let packData = dataImporter.currPack;
        let missionData = dataImporter.currMission;
        // -------

        storageManager.unlockMission(packData, missionData);
        // storageManager.unlockMission(dataImporter.currPack, dataImporter.currMission);
        // console.log('Next level unlocked.');

        this.setInteractionEnabled(true);
        this.interactive = true;

        this.camera = new Viewport({
            screenWidth: this.app.resizer.width,
            screenHeight: this.app.resizer.height,
            interaction: this.app.renderer.plugins.interaction
        });
        this.addChild(this.camera);

        this.world = new Container();
        this.world.interactive = true;
        this.camera.addChild(this.world);

        // Find mission map and create _tilemap for it.
        let map = this.setupMap(missionData);
        this._tilemap = new Tilemap(map, this.camera);
        this._tilemap.interactive = true;
        this.world.addChild(this._tilemap);

        // This is the world space UI.
        this.worldUI = new GameUI();
        this.world.addChild(this.worldUI);

        // Update the camera to correct world size.
        if (utils.isMobile.any){
            this.camera.zoomPercent(0.65, true);
        }

        this.world.position.set(-this.camera.worldScreenWidth * 0.5, -this.camera.worldScreenHeight * 0.5);
        this.camera.resize(this.app.resizer.width, this.app.resizer.height, this._tilemap.worldWidth, this._tilemap.worldHeight);
        this.camera.forceHitArea = new Rectangle(-this.camera.worldScreenWidth * 0.5, -this.camera.worldScreenWidth * 0.5, this._tilemap.worldWidth, this._tilemap.worldHeight);
        this.camera.clamp({ direction: 'all' });

        this.camera.on('moved', (e) => this._tilemap.updateChunks(e));

        // Merge game actors and extras with pack data.
        let actors = dataImporter.data?.game?.actors ? Object.assign({}, dataImporter.data.game.actors, packData.actors) : packData.actors;
        let extras = dataImporter.data?.game?.actors ? Object.assign({}, dataImporter.data.game.extras, packData.extras) : packData.extras;

        // This should probably be done before the load?
        // Find actors and extras needed for a mission.
        let neededActors = this.setupFilterAnims(actors, missionData.loadout.actors);
        let neededExtras = this.setupFilterAnims(extras, missionData.loadout.extras);

        this._player = new Player(this, neededActors, missionData);
        this._tilemap.addPlayer(this._player);
        this.camera.follow(this._player);

        // Setup screen space UI for minimap and score
        this.uiScreen = new UiScreen(this);
        this.addChild(this.uiScreen);
        this.uiScreen.position.set(this.app.resizer.width / 2, this.app.resizer.height / 2);

        // Setup screen space UI for overlays like the mission briefing.
        this.screenUI = new Container();
        this.addChild(this.screenUI);

        this.aiController = new AIController(this);

        // Setup the missionRunner.
        this.mr = new MissionRunner(this, neededExtras);
        this.mr.init(missionData);

        this._controller = new Controller(this);

        this.setupInput();

        //Setup UI
        this.ui.addChild(this.createMuteButton('TopRight'));
        this.addChild(this.createHelpButton('TopRight', () => {
            if (!this.mr || !this.mr.script && this.mr.script.objectives.length > 0) return;

            let command = new Command(this.mr.script.scriptAPI.showObjective, [this.mr.script.objectives[0].id, 1]);
            this.mr.script.runCommandsOnThread([command]);
        }));
        this.ui.addChild(this.createBackButton('TopLeft', "missionSelect", 'mission_select_btn', () => {
            nick_sdk_client.GameEventEmitter.sendGameEvent(
                nick_sdk_client.GameEventEmitter.ON_GAME_OVER,
                ""
            );
        }, dataImporter.currPack.tags.missionSelect));

        this.mr.startBriefing(this.screenUI);

        this.worldUI.showObjectiveArrow(this.player, this.tilemap);
    }

    get tilemap() {
        return this._tilemap;
    }

    get controller() {
        return this._controller;
    }

    get player() {
        return this._player;
    }

    get missionRunner() {
        return this.mr;
    }

    startTutorial() {
        console.log("start tutorial");
        let tutorial = new Tutorial(this._player);
        this.worldUI.addTutorial(tutorial);

        if (utils.isMobile.any){
            tutorial.startMobile(() => {
                this
                    .wait(0)
                    .call(() => this.worldUI.removeTutorial(tutorial));
            });
        } else {
            tutorial.start(() => {
                this
                    .wait(0)
                    .call(() => this.worldUI.removeTutorial(tutorial));
            });
        }

        window.tut = tutorial;
    }

    setupMap(missionData) {
        console.log(session);
        let map = session.maps.entries[0];
        if (session.maps.has(missionData.startMap)) map = session.maps.get(missionData.startMap);
        return map;
    }

    /*     setupActors(packData, missionData) {
            // Find actors needed for mission.
            let neededActors = {};
            Object.keys(packData.actors).forEach(key => {
                if (missionData.loadout.actors.includes(key)) {
                    neededActors[key] = packData.actors[key];
                }
            });

            return neededActors;
        } */

    setupFilterAnims(haystack, needles) {
        let filteredCollection = {};
        Object.keys(haystack).forEach(key => {
            if (needles.includes(key)) {
                filteredCollection[key] = haystack[key];
            }
        });

        return filteredCollection;
    }

    setupInput() {
        this.camera.on('clicked', (e) => {
            let newPos = this._tilemap.toLocal(e.screen);
            //this._player.moveTo(e.world.x, e.world.y);
            this._player.moveTo(newPos.x, newPos.y);
        }, this);

        /*         this.world.on(InteractionEvents.PointerTap, (e) => {
                    let newPos = this.camera.toWorld(e.data.global.x, e.data.global.y);
                    //let newPos = e.data.getLocalPosition(this._tilemap);
                    this._player.moveTo(newPos.x, newPos.y);
                }, this); */
    }

    /**
     */
    start() { }

    /**
     */
    transitionIn() { }

    resize(width, height) {
        this.world.position.set(-this.camera.worldScreenWidth * 0.5, -this.camera.worldScreenHeight * 0.5);
        this.camera.resize(width, height, this._tilemap.worldWidth, this._tilemap.worldHeight);
        this.camera.forceHitArea = new Rectangle(-this.camera.worldScreenWidth * 0.5, -this.camera.worldScreenWidth * 0.5, 6400, 6400);
        this.uiScreen.position.set(this.app.resizer.width / 2, this.app.resizer.height / 2);
        // TODO: Resize mission briefing.
    }

    update(dt) {
        super.update();

        this.controller.update(dt);
        //this._player.update(dt);
        this.aiController.update(dt);
        this._tilemap.update(dt);
        this.worldUI.update(dt);

        if (this.uiScreen){
            this.uiScreen.update();
        }
    }
}
